"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _propTypes = _interopRequireDefault(require("prop-types"));

class PortalWrapper extends _react.default.Component {
  constructor(props) {
    super(props);
    this.root = props.root || document.body;
    this.wrapper = document.createElement('div');
    this.handleScroll = this.handleScroll.bind(this);
    this.posTypes = ['absolute', 'fixed', 'relative'];
  }

  setPortalPosition() {
    const {
      node,
      position,
      vAlign,
      hAlign,
      offsetX,
      offsetY,
      width,
      height
    } = this.props;

    const wrapper = _reactDom.default.findDOMNode(this.wrapper);

    const {
      height: wrapperHeight,
      width: wrapperWidth
    } = wrapper.getBoundingClientRect();
    const pageWidth = document.body.clientWidth;
    const pageHeight = document.body.clientHeight;
    const w = width || wrapperWidth;
    const h = height || wrapperHeight;
    let x = 0;
    let y = 0;

    if (position !== 'fixed' && position !== 'absolute') {
      Object.assign(this.wrapper.style, {
        position,
        width: width ? `${width}px` : 'auto',
        height: height ? `${height}px` : 'auto'
      });
      return;
    }

    if (node) {
      const nodeEl = _reactDom.default.findDOMNode(node);

      const {
        top,
        bottom,
        left,
        right
      } = nodeEl.getBoundingClientRect();
      x = hAlign === 'left' ? left : pageWidth - right;
      y = vAlign === 'top' ? top : pageHeight - bottom;
    }

    x += offsetX;
    y += offsetY;

    if (vAlign === 'top' && y + h > pageHeight) {
      y = pageHeight - h;
    } else if (vAlign === 'bottom' && y - h < 0) {
      y = 0;
    }

    if (hAlign === 'left' && x + w > pageWidth) {
      x = pageWidth - width;
    } else if (vAlign === 'right' && x - w < 0) {
      x = 0;
    }

    const hOpposite = hAlign === 'left' ? 'right' : 'left';
    const vOpposite = vAlign === 'top' ? 'bottom' : 'top';
    const customStyles = {
      position,
      zIndex: 10000,
      [hAlign]: `${x}px`,
      [hOpposite]: 'auto',
      [vAlign]: `${y}px`,
      [vOpposite]: 'auto',
      width: width ? `${width}px` : 'auto',
      height: height ? `${height}px` : 'auto'
    };
    Object.assign(this.wrapper.style, customStyles);
  }

  handleScroll(e) {
    const {
      onScroll
    } = this.props;

    if (this.wrapper.contains(e.target)) {
      onScroll(e);
    } else {
      this.setPortalPosition();
    }
  }

  componentDidMount() {
    if (!this.posTypes.includes(this.props.position)) return;
    this.root.appendChild(this.wrapper);
    this.setPortalPosition();
    document.addEventListener('scroll', this.handleScroll, true);
  }

  componentDidUpdate(prevProps) {
    const {
      vAlign,
      hAlign,
      offsetX,
      offsetY,
      width,
      height
    } = this.props;

    if (prevProps.vAlign !== vAlign || prevProps.hAlign !== hAlign || prevProps.offsetX !== offsetX || prevProps.offsetY !== offsetY || prevProps.width !== width || prevProps.height !== height) {
      this.setPortalPosition();
    }
  }

  componentWillUnmount() {
    if (!this.posTypes.includes(this.props.position)) return;
    document.removeEventListener('scroll', this.handleScroll, true);
    this.root.removeChild(this.wrapper);
  }

  render() {
    const {
      children,
      position,
      root
    } = this.props;

    if (this.posTypes.includes(position)) {
      return _reactDom.default.createPortal(children, this.wrapper);
    }

    return _reactDom.default.createPortal(children, root);
  }

}

PortalWrapper.defaultProps = {
  offsetX: 0,
  offsetY: 0,
  vAlign: 'top',
  hAlign: 'left',
  position: 'fixed',
  onScroll: () => {}
};
var _default = PortalWrapper;
exports.default = _default;